import LORFacetItem from '@/routers/views/setup/lor-facets/lor-facets-item';

export class FacetsSerializer {

    private static INSTANCE = new FacetsSerializer();

    public static get instance() {
        return this.INSTANCE;
    }

    public normalizeFacets(payload: any) {
        const facets = payload.facets || [];
        const facetsList: any = {};
        facets.forEach((item: any) => {
            const filterKey = item.filterKey;
            const selectedOptions = item.selectedOptions;
            facetsList[filterKey.facetKey] = new LORFacetItem(item.labelKey, filterKey,
                item.isEditable, item.isSelected, item.options, selectedOptions);
        });
        return facetsList;
    }

    public normalizeCustomFacetMetadata(payload: any) {
        const results: any = payload || [];
        if (payload && !Array.isArray(payload)) {
            const valueList = Object.values(payload);
            return valueList.find((item) => Array.isArray(item)) || [];
        }
        return results;
    }

}

export const facetsSerializer = FacetsSerializer.instance;
